function formatNumber(number) {
    // Handle null, undefined, or non-numeric values more gracefully
    if (number === null || number === undefined) {
      return '0';
    }
    
    // Convert string numbers to actual numbers
    if (typeof number === 'string') {
      number = parseFloat(number);
    }
    
    if (typeof number !== 'number' || isNaN(number)) {
      console.error('Invalid number:', number);
      return '0';
    }
    
    if (number >= 1_000_000_000) {
      return (number / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
    }
    if (number >= 1_000_000) {
      return (number / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (number >= 1_000) {
      return (number / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    return number.toString();
  }

  module.exports = formatNumber;